module.exports = __webpack_public_path__ + "img/logo.c2563692.png";